// extracted by mini-css-extract-plugin
export var button = "_32-1";
export var featuredLink = "_32-4";
export var spinner = "_32-2";
export var spinnerContainer = "_32-3";
export var text = "_32-0";